import * as React from "react";
import {Field} from "react-final-form";
import {EstadosDocumentos as estadosDctos} from "../../bandeja/modelo/EstadosTarea";

export default class EstadosDocumentos extends React.Component<EstadosDocumentosProps> {

    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {estadosDctos.map(estado => {
                                return <option key={estado} value={estado}>{estado}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface EstadosDocumentosProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/EstadosDocumentos.tsx